<template lang="pug">
    article.assets(:class="{'assets--swiper-mode': isSwiperOn}")

        Preloader(:class='{hide: swiperLoaded}')

        .swiper-container(ref='swiperContainer')
            .swiper-wrapper

                section.swiper-slide.asset(
                    v-for='({name, id, link, infograph, subassets, index, subIndex, sub, category, categoryname, theme, logo, description, counters, countersTrigger} = asset, blockIndex) in assets',
                    :data-index='index',
                    :data-subindex='subIndex',
                    :data-infograph='infograph',
                    :data-sub='sub',
                    :data-id='id',
                    :data-category='category',
                    :style='`--block-theme: ${theme};`',
                    ref='slide'
                    )

                    .asset__backimage(v-if='countersTrigger && !isMobile()', :data-background='require(`@/assets/img/assets/${id}.jpg`)')
                        .swiper-lazy-preloader

                    lazy-background(v-if='countersTrigger && isMobile()', :src='require(`@/assets/img/assets/${id}.jpg`)', position='50% 50%', size='cover', repeat='no-repeat')

                    .asset__nav(v-observe-visibility='visibilityChanged')
                        .asset__label {{categoryname}}

                    .asset__heading(v-if='link', :class='{info: countersTrigger}', v-observe-visibility='visibilityChanged')
                        a.asset__link(:href='link', rel='noopener', :title='name', target='_blank')
                            h1.h1.asset__logo.asset__logo--text(v-if='!logo') {{name}}
                            .asset__logo.asset__logo--pic(v-if='logo && id')
                                img(:src='"@/assets/img/logo/" + id + ".svg"', :alt='name')

                    .asset__heading(v-else, :class='{info: countersTrigger}', v-observe-visibility='visibilityChanged')
                        h1.h1.asset__logo.asset__logo--text(v-if='!logo') {{name}}
                        .asset__logo.asset__logo--pic(v-if='logo && id')
                            img(:src='"@/assets/img/logo/" + id + ".svg"', :alt='name')

                    p.asset__description(v-if='description && !countersTrigger', v-html='description', v-observe-visibility='visibilityChanged')

                    .asset__counters(v-if='(counters && countersTrigger) || sub', v-observe-visibility='visibilityChanged')

                        .asset__pusher(v-if='counters.length < 3')
                        .asset__counter(v-for='({number, description, info, showInfo} = counter, counterIndex) in counters')

                            .asset__counter-number(v-html="number")

                            .asset__counter-description(@click='() => {if (info) openInfo(blockIndex, counterIndex)}', :class='{clickable: info}')
                                span(v-html='description')
                                br
                                //- span.asset__counter-popup(:class='{show: info && showInfo}') {{info}}
                                span.asset__counter-popup.show {{info}}
                        .asset__pusher(v-if='counters.length < 3')

                .swiper-slide(v-if='!isMobile()')

        .assets-arrow-selector
            .assets-arrow-selector__arrow.assets-arrow-selector__arrow--prev(@click='changeAsset("prev")')
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
                .show-asset.show-asset--prev
                    span {{showAsset.prev}}

            .assets-arrow-selector__arrow.assets-arrow-selector__arrow--next(@click='changeAsset("next")')
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
                .show-asset.show-asset--next
                    span {{showAsset.next}}

        .assets__arrow-scroll
            svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

        Footer.assets__footer


</template>

<script>
import Preloader from '../components/Preloader.vue';
import Footer from '../components/Footer.vue';
import Swiper, {Mousewheel, EffectFade, Lazy} from 'swiper';
Swiper.use([Mousewheel, EffectFade, Lazy]);
// import {TweenMax, Power2} from 'gsap';
import assetsData from '../assets/data/assets.json';

export default {
    name: 'Assets',

    props: {
        category: {
            required: false,
            type: String
        },
        id: {
            required: false,
            type: String
        }
    },

    components: {
        Preloader,
        Footer
    },

    data() {
        return {
            swiper: null,
            currentTransitionSpeed: 0,
            assets: [],
            swiperLoaded: false,
            isSwiperOn: false
        };
    },

    computed: {
        showAsset() {
            let newNextPrev = {
                next: '',
                prev: ''
            };
            if (this.swiperLoaded && !this.isMobile) {
                let currentAssetIndex = this.swiper.slides[this.swiper.activeIndex].dataset.index
                    ? this.swiper.slides[this.swiper.activeIndex].dataset.index
                    : this.swiper.slides[this.swiper.activeIndex - 1].dataset.index;
                newNextPrev.next = this.swiper.realIndex < this.assets.length - 1 ? this.assets[this.getNextAssetIndex(currentAssetIndex, 'next')].name : '';
                newNextPrev.prev = this.swiper.realIndex > 0 ? this.assets[this.getNextAssetIndex(currentAssetIndex, 'prev')].name : '';
            }
            return newNextPrev;
        }
    },

    watch: {
        $route(to) {
            this.goToSlide(to.params.category, to.params.id);
        }
    },

    beforeMount() {
        const assetsArray = [];

        let sortedAssetData = this.sortAssetsArray(assetsData);

        sortedAssetData.forEach((asset, index) => {
            let assetCopy = {...asset};
            asset.index = index;
            asset.sub = false;
            assetsArray.push(asset);
            assetCopy.countersTrigger = true;
            assetCopy.infograph = true;
            if (assetCopy.counters) assetsArray.push(assetCopy);

            if (asset.subassets) {
                asset.subassets.forEach((subasset, subIndex) => {
                    subasset.sub = true;
                    subasset.index = index;
                    subasset.subIndex = subIndex;
                    assetsArray.push(subasset);
                });
            }
        });

        this.assets = assetsArray;

        this.checkProps();
    },

    mounted() {
        this.$store.dispatch('setTheme', 'white');
        if (!this.isMobile()) {
            this.initSw();
            this.isSwiperOn = true;
        } else {
            this.isSwiperOn = false;
            this.swiperLoaded = true;
            this.goToSlide(this.category, this.id);
        }
        window.addEventListener('keyup', this.arrowEvent);
    },

    beforeDestroy() {
        if (this.swiper) {
            this.isSwiperOn = false;
            this.swiper.destroy();
        }
        window.removeEventListener('keyup', this.arrowEvent);
    },

    methods: {
        arrowEvent(e) {
            if (e.key === 'ArrowRight') {
                this.changeAsset('prev');
            } else if (e.key === 'ArrowLeft') {
                this.changeAsset('next');
            }
        },

        initSw() {
            let initialSlide = this.assets.findIndex(asset => {
                if (asset.category === this.category && asset.id === this.id) return true;
            });
            if (initialSlide < 0) initialSlide = 0;

            const that = this;
            this.swiper = new Swiper(this.$refs.swiperContainer, {
                direction: 'vertical',
                mousewheel: {
                    eventsTarged: this.$refs.swiperContainer
                },
                speed: 1300,
                initialSlide,
                watchSlidesProgress: true,
                virtualTranslate: true,
                effect: 'fade',
                simulateTouch: false,
                keyboard: true,
                lazy: {
                    loadPrevNext: true,
                    elementClass: 'asset__backimage'
                },
                on: {
                    init() {
                        const swiper = this;
                        that.setActiveThemeColor(swiper);
                        that.setRouterPath(swiper);
                        swiper.allowSlideNext = false;
                        setTimeout(() => {
                            swiper.allowSlideNext = true;
                        }, 1000);
                        that.swiperLoaded = true;
                    },
                    reachEnd() {
                        that.goNextArticle();
                    }
                },
                breakpoints: {
                    480: {
                        direction: 'horizontal'
                    }
                }
            });

            this.swiper.on('slideChange', () => {
                this.setActiveThemeColor(this.swiper);
                this.setRouterPath(this.swiper);
            });

            this.swiper.setTranslate(() => (this.swiper.animating = false));
        },

        checkIfNextSlideIsSubcategory(curIndex) {
            if (this.$refs.slide[curIndex + 1].dataset.sub) {
                return true;
            } else {
                return false;
            }
        },

        changeAsset(direction) {
            if ((this.swiper.isBeginning && direction === 'prev') || (this.swiper.isEnd && direction === 'next')) return;

            let currentAssetIndex = this.swiper.slides[this.swiper.activeIndex].dataset.index
                ? this.swiper.slides[this.swiper.activeIndex].dataset.index
                : this.swiper.slides[this.swiper.activeIndex - 1].dataset.index;

            if (currentAssetIndex === 0 && direction === 'prev') return;
            if (currentAssetIndex === assetsData.length && direction === 'next') return;
            let nextAssetIndex = this.getNextAssetIndex(currentAssetIndex, direction);

            this.swiper.slideTo(nextAssetIndex);
        },

        getNextAssetIndex(currentAssetIndex, direction) {
            let targetAssetIndex = direction === 'prev' ? Number(currentAssetIndex) - 1 : Number(currentAssetIndex) + 1;
            let resultSlideIndex = 0;

            this.$refs.slide.forEach((slide, index) => {
                if (!slide.dataset.sub && slide.dataset.infograph !== 'true') {
                    if (Number(slide.dataset.index) === targetAssetIndex) {
                        resultSlideIndex = index;
                    }
                }
            });
            return resultSlideIndex;
        },

        setActiveThemeColor(swiper) {
            swiper;
            // document.documentElement.style.setProperty('--color-theme', this.assets[swiper.realIndex].theme);
        },

        setRouterPath(swiper) {
            if (swiper.realIndex !== this.assets.length) {
                const actualRouteParams = {
                    name: this.$route.name,
                    params: {
                        id: this.$route.params.id,
                        category: this.$route.params.category
                    }
                };

                const newRouteParams = {
                    name: 'assets',
                    params: {
                        id: this.assets[swiper.realIndex].id,
                        category: this.assets[swiper.realIndex].category
                    }
                };

                // не меняем роутинг если слайд в предыдущем роуте
                if (actualRouteParams.params.id === newRouteParams.params.id && actualRouteParams.params.category === newRouteParams.params.category) return;
                // игнорируем смену роута в подразделах рамблера
                if (newRouteParams.params.category === undefined || newRouteParams.params.id === undefined) return;

                this.$router.push(newRouteParams).catch(() => {});
            }
        },

        openInfo(blockIndex, counterIndex) {
            this.assets[blockIndex].counters[counterIndex].showInfo = !this.assets[blockIndex].counters[counterIndex].showInfo;
        },

        checkProps() {
            if (!this.category) {
                if (this.swiper && this.swiper.realIndex !== this.assets.length) {
                    this.$router
                        .push({
                            name: 'assets',
                            params: {
                                id: this.assets[0].id,
                                category: this.assets[0].category
                            }
                        })
                        .catch(() => {});
                }
            } else if (!this.id) {
                let firstElementInCategory = this.assets.findIndex(asset => {
                    if (asset.category === this.category) return true;
                });

                if (firstElementInCategory < 0) firstElementInCategory = 0;
                if (this.swiper.realIndex !== this.assets.length) {
                    this.$router
                        .push({
                            name: 'assets',
                            params: {
                                id: this.assets[firstElementInCategory].id,
                                category: this.assets[firstElementInCategory].category
                            }
                        })
                        .catch(() => {});
                }
            }
        },

        goToSlide(category, id) {
            if (this.isMobile()) {
                this.scrollToSlide(id);
                return;
            }
            if (this.assets[this.swiper.realIndex].category === category && this.assets[this.swiper.realIndex].id === id) return;
            let matchedSlide = this.assets.findIndex(asset => {
                if (asset.category === category && asset.id === id) return true;
            });
            if (matchedSlide < 0) matchedSlide = 0;
            this.swiper.slideTo(matchedSlide);
        },

        scrollToSlide(id) {
            let element = this.$refs.slide.find(el => el.dataset.id === id);

            this.$nextTick(() => {
                element.scrollIntoView();
            });
        },

        sortAssetsArray(arr) {
            let servicesCategories = ['media', 'video', 'services', 'infrastructure'];
            let categoriesArrays = [];

            servicesCategories.forEach((serviceCategory, index) => {
                categoriesArrays[index] = arr.filter(item => item.category === serviceCategory);
                categoriesArrays[index].sort((a, b) => {
                    const la = a.name.toLowerCase().charCodeAt(0);
                    const lb = b.name.toLowerCase().charCodeAt(0);
                    const nameA = a.name.toLowerCase(),
                        nameB = b.name.toLowerCase();

                    if (la > 1071 && lb > 1071) {
                        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    }
                    if (la > 1071 || lb > 1071) {
                        return nameA > nameB ? -1 : nameA > nameB ? 1 : 0;
                    } else {
                        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    }
                });
            });

            let sortedAssetData = categoriesArrays[0].concat(categoriesArrays[1], categoriesArrays[2], categoriesArrays[3]);

            return sortedAssetData;
        },

        goNextArticle() {
            this.$router.push({path: '/technologies/bigdata/b2b'}).catch(() => {});
        },

        isMobile() {
            return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
        },

        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show-mobile');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';

:root {
    --block-theme: #232222;
    --color-theme: #232222;
    --vh: 5.68px;
}

// .assets {
//     opacity: 1;
//     transition: opacity 0.4s ease 0.5s;

//     &.hidden {
//         opacity: 0;

//         @media (--viewport-tablet) {
//             opacity: 1;
//         }
//     }
// }

.assets {
    &__footer {
        position: relative;
        z-index: 5;

        .assets--swiper-mode & {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
        }
    }

    &__arrow-scroll {
        position: absolute;
        width: 100%;
        height: 0.6em;
        bottom: #{2.2em + 0.2em + 2.86em};
        z-index: 3;
        pointer-events: none;
        text-align: center;
        animation: arrow 1.5s infinite;

        svg {
            width: 30px;
            height: auto;
            fill: white;
            transform: rotate(90deg);
        }

        @media (--viewport-tablet) {
            display: none;
        }
    }

    @keyframes arrow {
        0% {
            opacity: 0;
            transform: translateY(-1em);
        }
        75% {
            opacity: 1;
            transform: translateY(1em);
        }
        90% {
            opacity: 0;
            transform: translateY(1em);
        }
        100% {
            opacity: 0;
            transform: translateY(1em);
        }
    }
}

.swiper {
    &-container {
        width: 100%;
        height: 100vh;
        perspective: 800px;
        background-color: #232222;

        @media (--viewport-tablet) {
            height: auto;
        }
    }

    &-wrapper {
        transform-style: preserve-3d;
        // overflow: hidden;

        @media (--viewport-tablet) {
            overflow: auto;
            display: block;
        }
    }

    &-slide {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        pointer-events: none;
        color: white;
        background: var(--block-theme);
        transition: background 0.3s ease 0.3s;

        &[data-sub='true'] {
            background: url('../assets/img/assets/rambler.jpg') center center no-repeat;
            background-size: cover;

            &:before {
                content: '';
                display: inline-block;
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.6);
            }
        }

        @media (--viewport-tablet) {
            pointer-events: all;
            -webkit-overflow-scrolling: touch;
            height: auto;
            min-height: 100vh;
        }

        &-active {
            pointer-events: all;
        }
    }
}

.asset {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    justify-content: flex-start;

    @media (--viewport-tablet) {
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
        justify-content: center;
    }

    &__nav {
        position: absolute;
        top: 20vh;
        left: 0;
        width: 100%;
        z-index: 2;

        @supports (--css: variables) {
            top: calc(var(--vh) * 20);
        }

        @media (--viewport-tablet) {
            top: 5em;
        }
    }

    &__label {
        box-sizing: border-box;
        margin: 0 auto;
        text-transform: uppercase;
        opacity: 0.5;
        font-family: var(--font-accent);
        margin-bottom: 1em;
        text-align: center;
    }

    &__link {
        text-decoration: none;
    }

    &__heading,
    &__description,
    &__counters {
        opacity: 0;
        transition: opacity 0.1s ease, transform 0.3s ease-out 0.5s;
        transform: translateY(20px);

        @media (--viewport-tablet) {
            transition: opacity 0.5s ease 0.5s, transform 0.5s ease-out 0.5s;
        }

        &.show-mobile {
            @media (--viewport-tablet) {
                transform: translateY(0px);
                opacity: 1;
            }
        }
    }

    &__heading {
        position: relative;
        z-index: 1;
        font-size: 2em;
        text-transform: uppercase;
        padding-top: calc(1.4em + 21vh);

        &.info {
            transform: translateY(0px);
            opacity: 1;

            @media (--viewport-tablet) {
                opacity: 0;
                transform: translateY(20px);
            }

            &.show-mobile {
                @media (--viewport-tablet) {
                    transform: translateY(0px);
                    opacity: 1;
                }
            }
        }

        @media (--viewport-tablet) {
            padding-top: 20vh;
        }
    }

    &__logo {
        &--text {
            min-height: calc(100vw * 195 / 1920);

            @media (--viewport-tablet) {
                min-height: calc(100vw * 95 / 320);
            }
        }

        &--pic {
            width: calc(var(--layout-column-width) * 4 + var(--layout-gutter-width) * 3);

            @media (--viewport-tablet) {
                width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 10);
            }

            img {
                width: 100%;
            }
        }
    }

    &__backimage {
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;

        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    .lazy-background {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;

        &:before {
            position: relative;
            z-index: 2;
            content: '';
            display: inline-block;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    &__description {
        font-size: 1em;
        line-height: 1.4;
        text-align: justify;
        max-width: calc((var(--layout-column-width) * 6) + (var(--layout-gutter-width) * 5));
        // margin-top: 4em;

        @media (--viewport-laptop-l) {
            max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
            margin-top: 2em;
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            margin-top: 2em;
            text-align: center;
        }
    }

    &-popup {
        font-size: 0.8em;
    }

    &__counters {
        position: relative;
        z-index: 1;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        grid-column-gap: 20px;
        margin-top: 3em;
        margin-top: 0em;
        padding: 0 7vw;
        box-sizing: border-box;

        @media (--viewport-laptop-l) {
            margin-top: 2em;
        }

        @media (--viewport-tablet) {
            display: block;
            padding-bottom: 8vh;
            margin-top: 1em;
        }
    }

    &__counter {
        text-align: center;
        padding: 10px 20px;

        &-number {
            font-size: 3em;

            @media (--viewport-laptop-l) {
                font-size: 2em;
            }
        }

        &-description {
            display: inline-block;
            font-size: 0.9em;
            max-width: 25vw;

            @media (--viewport-laptop-l) {
                font-size: 0.8em;
            }

            @media (--viewport-tablet) {
                max-width: unset;
            }

            span {
                span {
                    color: red;
                }
            }

            &.clickable {
                // cursor: pointer;
            }
        }

        &-popup {
            opacity: 0;
            font-size: 0.7em;
            transition: opacity 0.3s ease;

            &.show {
                opacity: 1;
            }
        }
    }

    &.swiper-slide-active {
        .asset {
            &__heading,
            &__description,
            &__counters {
                opacity: 1;
                transform: translateY(0px);
            }

            &__heading {
                transition: opacity 0.3s ease 0.3s, transform 0.3s ease-out 0.3s;

                &.info {
                    transition: none;
                }
            }

            &__description {
                transition: opacity 0.3s ease 0.4s, transform 0.3s ease-out 0.4s;
            }

            &__counters {
                transition: opacity 0.3s ease 0.5s, transform 0.3s ease-out 0.5s;
            }
        }
    }

    &.swiper-slide-prev {
        .asset {
            &__heading {
                opacity: 1;
                transform: translateY(0);
                transition: none;
            }
        }
    }
}

.assets-arrow-selector {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 5vw;
    pointer-events: none;

    @media (--viewport-tablet) {
        display: none;
        align-items: flex-start;
        height: 15vw;
        top: 100%;
        top: calc(var(--vh) * 100);
        transform: translateY(-100%);
        padding: 0 5vw;
    }

    &__arrow {
        position: relative;
        cursor: pointer;
        font-size: 2em;
        color: white;
        pointer-events: auto;

        svg {
            width: 30px;
            height: auto;
            fill: white;
        }

        &--prev {
            svg {
                transform: rotate(180deg);
            }
        }

        @media (--viewport-tablet) {
            width: 10vw;
            height: 10vw;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
                position: relative;
                z-index: 2;
                width: 5vw;
                height: auto;
            }

            &:before {
                content: '';
                position: absolute;
                display: inline-block;
                width: 100%;
                height: 100%;
                background: var(--color-theme);
                border-radius: 10vw;
                transition: background-color 0.5s ease 0.4s;
            }
        }

        .show-asset {
            position: absolute;
            font-size: 14px;
            height: 100%;
            top: 0;
            display: flex;
            pointer-events: none;
            transition: opacity 0.4s ease;
            opacity: 0;

            span {
                margin: auto;
            }

            &--next {
                transform: translateX(-110%);
            }

            &--prev {
                transform: translateX(60px);
            }
        }

        @media not all and (hover: none) {
            &:hover {
                .show-asset {
                    opacity: 1;
                }
            }
        }
    }
}

.swiper-lazy-preloader {
    display: none;
}

// .home {
//     font-family: var(--font-main);
//     @media (--viewport-tablet) {
//         background: red;
//     }
//     &__img {
//         border: 1px dashed;
//     }
// }
</style>
